import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES } from '../../config/url.servicio'

@Injectable()
export class ConceptosEgresosProvider {

  constructor(public http: Http) {

  }

  buscarConceptosEgresosPorEmpresa(companiasId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarConceptosEgresosPorEmpresa",
        parameters : {companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarConceptosEgresosPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }

  guardar(conceptoEgreso: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: conceptoEgreso.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "conceptosEgresos",
          ...conceptoEgreso
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options).map((data) => {
        data.json()}
      , error => {
        console.log(error)});
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.post(`${url}/query`, conceptoEgreso, options)
        .map((data) => data.json())
   }
  }

  eliminar(conceptoEgresoElimina: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: conceptoEgresoElimina.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "conceptosEgresos",
          ...conceptoEgresoElimina
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&conceptosEgresosId=${conceptoEgresoElimina.conceptosEgresosId}&nombreTabla=conceptosEgresos`, options)
    }
 }
}



// WEBPACK FOOTER //
// ./src/providers/conceptos-egresos/conceptos-egresos.ts